import React from "react";
import { Alert, Snackbar } from "@mui/material";
import { createRoot } from "react-dom/client";

export const toastAlert = (message, severity = "info", duration = 4000) => {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = createRoot(container);

  const handleClose = () => {
    root.unmount();
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
  };

  root.render(
    <Snackbar
      open
      autoHideDuration={duration}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={severity} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};
